import React from "react";
import "./hotel.css";

const Shimmer = ({ className = "" }) => (
  <div className={`villa-skeleton-shimmer ${className}`} />
);

const VillaCardSkeleton = () => {
  return (
    <div className="bg-[#EAEAEA] w-[96%] md:w-full relative mx-auto font-jt border-[3px] border-[#2A2A2B] lg:border-none lg:shadow-md rounded-[30px] lg:rounded-2xl shadow-xl mt-5 flex flex-col md:flex-row overflow-hidden">
      {/* Image */}
      <div className="w-full md:w-[40%] p-2">
        <Shimmer className="w-full h-[210px] lg:h-[300px] rounded-3xl lg:rounded-2xl" />
      </div>

      {/* Mobile content — matches mobile card layout */}
      <div className="w-full md:hidden px-3 pb-3 space-y-3">
        <div className="flex items-center justify-between gap-2">
          <Shimmer className="h-6 w-[65%] rounded" />
          <div className="flex items-center gap-1.5">
            <Shimmer className="h-4 w-16 rounded" />
            <Shimmer className="h-5 w-5 rounded" />
          </div>
        </div>
        <Shimmer className="h-4 w-24 rounded" />
        <div className="grid grid-cols-3 gap-2">
          {[1, 2, 3].map((i) => (
            <Shimmer key={i} className="h-10 rounded-md" />
          ))}
        </div>
      </div>

      {/* Desktop content */}
      <div className="hidden md:block w-full md:w-[43%] p-2 md:p-6 space-y-4">
        <Shimmer className="h-5 w-28 rounded" />
        <Shimmer className="h-7 w-3/4 rounded" />
        <Shimmer className="h-4 w-1/2 rounded" />
        <div className="grid grid-cols-4 gap-2 mt-4">
          {[1, 2, 3, 4].map((i) => (
            <Shimmer key={i} className="h-14 rounded-md" />
          ))}
        </div>
        <div className="flex gap-3 mt-4">
          {[1, 2, 3, 4, 5, 6].map((i) => (
            <Shimmer key={i} className="h-8 w-8 rounded-full" />
          ))}
        </div>
      </div>

      {/* Price panel — compact on mobile */}
      <div className="w-full md:w-[17%] bg-[#2A2A2B] rounded-b-[26px] md:rounded-none md:rounded-r-2xl p-3 md:p-4 flex flex-row md:flex-col justify-between md:justify-center items-center md:items-end gap-2 md:gap-3">
        <Shimmer className="h-4 w-14 rounded bg-gray-600" />
        <Shimmer className="h-6 w-24 rounded bg-gray-600" />
        <Shimmer className="hidden md:block h-3 w-20 rounded bg-gray-600" />
      </div>
    </div>
  );
};

export default VillaCardSkeleton;
